// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"a951798a","440":"656d4b30","540":"0c0b8a89","709":"a951798a"}[chunkId] + ".chunk.css";
};